<template>
  <div style="width: 100%;">
    <slot />
    <div class="management-section-wrapper">
      <v-card-title>
        <span class="management-section-title">{{ $tc("License") }}</span>
        <v-spacer />
      </v-card-title>
      <v-tabs v-model="tab" align-with-title class="user-tab-container pl-0">
        <v-tabs-slider color="accent"></v-tabs-slider>

        <v-tab
          v-for="item in items"
          :key="item"
          :class="{ 'user-tab-active': tab === items.indexOf(item) }"
        >
          {{ item }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item v-for="item in items" :key="item">
          <v-card flat>
            <VueShowdown
              style="text-align: justify; padding: 0 20px 20px 20px"
              :markdown="getLicense(item)"
            ></VueShowdown>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import webLicenseFile from "./Files/WebFELicenses.txt";

export default {
  name: "LicensesList",

  data() {
    return {
      tab: 0,
      items: ["web", "fiber backend", "tasks backend"],
      fieldLicense: null,
      fiberLicense: null,
      webLicense: null
    };
  },

  created() {
    this.getFieldLicenses();
    this.getFiberLicenses();
    this.getWebLicenses();
  },

  computed: {
    fieldLicenses() {
      return this.fieldLicense ? "" + this.fieldLicense : "";
    },

    fiberLicenses() {
      return this.fiberLicense ? "" + this.fiberLicense : "";
    },

    webLicenses() {
      return this.webLicense ? "" + this.webLicense : "";
    }
  },

  methods: {
    ...mapActions(["fetchFieldLicenses", "fetchFibercloudLicenses"]),

    async getFieldLicenses() {
      try {
        this.fieldLicense = await this.fetchFieldLicenses();
      } catch (e) {
        console.log(e);
      }
    },

    async getFiberLicenses() {
      try {
        this.fiberLicense = await this.fetchFibercloudLicenses();
      } catch (e) {
        console.log(e);
      }
    },

    getWebLicenses() {
      this.webLicense = webLicenseFile;
    },

    getLicense(item) {
      switch (item) {
        case "web":
          return this.webLicenses;
        case "fiber backend":
          return this.fiberLicenses;
        case "tasks backend":
          return this.fieldLicenses;
        default:
          break;
      }
    }
  }
};
</script>

<style scoped>
.user-tab-active {
  color: #4fa2b7 !important;
}
</style>

<style>
.v-tabs__container--align-with-title {
  padding-left: 10px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/User/Licenses/LicensesList.vue